<h2 i18n="@@billingContract-Confirmation">Confirmation</h2>
<mat-divider></mat-divider>
<div class="success-header-container">
	<h4 i18n="@@billingContract-Success" class="success-header">Success!</h4>
	<h4 class="success-header success-header-company-name">{{ companyName }}</h4>
	<h4 class="success-header" i18n="@@billingContract-hasBeenAddedAsANewCustomer">has been added as a new customer.</h4>
</div>
<div class="button-container">
	<button
		class="primary-small-button"
		i18n="@@billingContract-returnToCustomerList"
		(click)="onReturnToCustomerListClick()"
		data-automation-id="return-to-customer-list-button"
	>
		Return to Customer List
	</button>
	<button
		class="secondary-small-button"
		i18n="@@billingContract-addAnotherCustomer"
		(click)="onAddButtonClick()"
		data-automation-id="add-another-customer-button"
	>
		+ Add Another Customer
	</button>
</div>
